export default __webpack_public_path__ + "static/media/upload-file.acd43153.svg";